// De taken per huishouden die nog gedaan moeten worden, zodat het overzicht
// de vraag 'wat staat hier nog open' beantwoordt zonder elk huishouden te
// openen (updateverzoek BuurtKlusBedrijf, 2026-09-15).
//
// Het gaat om de SUBTAKEN, niet om de afspraken. Een afspraak is een moment en
// staat al in de kolom 'volgende afspraak'; een subtaak is het werk zelf.
// Alleen subtaken dragen een stand (Te doen / Bezig / Klaar), en dat is precies
// wat 'nog te doen' betekent.
//
// LET OP bij het lezen: het invoerveld in SubTasks.jsx heet op een huishouden
// 'Kies of typ een klus (met categorie)'. De kolom heet TAKEN. Die twee woorden
// staan naast elkaar in de app; verander er geen van zonder de ander.
//
// AI-CONTEXT: See docs/features/household-overview-table-and-statuses.md

import subtasksPerAdress, { OPEN_STATUSES, isOpenSubtask } from './subtasksPerAdress'

/**
 * @typedef {object} TaskCount
 * @property {number} open - Taken die nog gedaan moeten worden
 * @property {number} totaal - Alle taken van dit huishouden
 */

/**
 * Open en totaal aantal taken per huishouden.
 *
 * Het vinden van het huishouden bij een subtaak zit in `subtasksPerAdress`: dat
 * is niet triviaal (een subtaak draagt vaak geen eigen `AdressID`) en het
 * tabblad 'Subtaken' op het huishouden en het lijstje bij een afspraak moeten
 * precies dezelfde regel volgen. Hier blijft alleen het tellen over.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * @param {Array<object>} [tasks] - Alle Tasks-documenten van de organisatie
 * @returns {Record<string, TaskCount>} Huishoudens zonder taken ontbreken
 */
const openTasksPerAdress = (tasks) => {
    const perAdres = subtasksPerAdress(tasks)

    /** @type {Record<string, TaskCount>} */
    const result = {}

    Object.entries(perAdres).forEach(([adressId, subtaken]) => {
        result[adressId] = {
            open: subtaken.filter(isOpenSubtask).length,
            totaal: subtaken.length,
        }
    })

    return result
}

export { OPEN_STATUSES, isOpenSubtask }
export default openTasksPerAdress
